import React, { useEffect, useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { server } from "../../server";
import { toast } from "react-toastify";
import { loadSellers, setSellerOnLogin, setUser } from "../../redux/actions/user";
import { getStoredCurrentProfile, setStoredCurrentProfile } from "../../utils/shopProfile";
import { cacheAuthUser, cacheUserShops, persistAuthToken } from "../../utils/authSession";

const ShopLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [identifier, setIdentifier] = useState(""); // Renamed from shopHandle
  const [password, setPassword] = useState("");
  const [visible, setVisible] = useState(false);
  const { isSeller, seller, sellers: sellerProfiles } = useSelector((state) => state.seller);

  useEffect(() => {
    if (isSeller && seller) {
      if (seller.isOnboardingComplete === false) {
        navigate("/onboarding");
      } else {
        navigate(`/dashboard/${seller.handle}`);
      }
    }
  }, [isSeller, seller, navigate]);

  useEffect(() => {
    dispatch(loadSellers());
  }, [dispatch]);

  useEffect(() => {
    const currentProfileName = getStoredCurrentProfile();
    if (currentProfileName) {
      const foundSeller = sellerProfiles.find(seller => seller.name === currentProfileName);
      if (foundSeller) {
        setIdentifier(foundSeller.handle);
      }
    }
  }, [sellerProfiles]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!identifier || !password) {
      toast.error("Please provide your account email, unique ID, handle, or shop handle and password");
      return;
    }

    try {
      const response = await axios.post(
        `${server}/shop/login-shop`,
        { identifier, password },
        { withCredentials: true }
      );

      toast.success("Login Successful!");
      const { shop, token, user } = response.data;
      if (token) {
        persistAuthToken(token);
      }
      if (user) {
        cacheAuthUser(user);
        dispatch(setUser(user));
      }
      if (shop) {
        cacheUserShops([shop]);
      }
      if (shop) {
        dispatch(setSellerOnLogin(shop));
        setStoredCurrentProfile(shop.name);
      }
      dispatch(loadSellers());
    } catch (err) {
      console.error('Error during login:', err.response?.data);
      toast.error(err.response?.data?.message || "Login failed");
    }
  };

  if (isSeller && seller) {
    return null;
  }

  return (
    <div className="shop-login-component-container">
      <div className="shop-login-component-shell">
        <div className="shop-login-component-header">
          <p className="shop-login-component-eyebrow">Shop Access</p>
          <h2>Login to your shop</h2>
        </div>
        <div className="shop-login-component-form-container">
          <div className="shop-login-component-form">
            <form className="shop-login-component-form-elements" onSubmit={handleSubmit}>
              <div className="shop-login-component-form-group">
                <label htmlFor="identifier">Account Email, Unique ID, @Handle, or Shop Handle</label>
                <input
                  id="identifier"
                  type="text"
                  name="identifier"
                  required
                  value={identifier}
                  onChange={(e) => setIdentifier(e.target.value)}
                  className="shop-login-component-input"
                  autoComplete="username"
                />
              </div>
              <div className="shop-login-component-form-group shop-login-component-password-container">
                <label htmlFor="password">Password</label>
                <div className="shop-login-component-password-field">
                  <input
                    id="password"
                    type={visible ? "text" : "password"}
                    name="password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="shop-login-component-input"
                    autoComplete="current-password"
                  />
                  <button
                    type="button"
                    className="shop-login-component-eye-icon"
                    onClick={() => setVisible((currentVisible) => !currentVisible)}
                    aria-label={visible ? "Hide password" : "Show password"}
                  >
                    {visible ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                  </button>
                </div>
              </div>
              <div>
                <button type="submit" className="shop-login-component-button">
                  Login
                </button>
              </div>
              <div className="shop-login-component-forgot-password">
                <Link to="/shop/forgot-password">Forgot Password?</Link>
              </div>
              <div className="shop-login-component-footer">
                <h4>Don’t have an account?</h4>
                <Link to="/shop-create">Sign Up</Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopLogin;

